'use client';

import { useMemo } from 'react';
import { createTranslator, useLocale, useMessages } from 'next-intl';

import { registerClientTranslator } from './client-translator';

/**
 * Publishes the active locale's translator to `translateOutsideReact` so plain
 * modules can produce localized copy. Renders nothing; mounted once inside
 * `NextIntlClientProvider`.
 */
const ClientTranslatorBridge = () => {
  const locale = useLocale();
  const messages = useMessages();

  // Registered during render rather than in an effect so a toast fired by an
  // event handler on the very first paint already sees the right locale.
  useMemo(() => {
    registerClientTranslator(createTranslator({ locale, messages }));
  }, [locale, messages]);

  return null;
};

export default ClientTranslatorBridge;
